import { Mark, mergeAttributes } from '@tiptap/core'

export interface WordMarkAttributes {
  start: number
  end: number
}

export const WordMark = Mark.create({
  name: 'wordMark',

  addAttributes() {
    return {
      start: { default: 0 },
      end: { default: 0 },
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-word-start]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-word-start': HTMLAttributes.start,
        'data-word-end': HTMLAttributes.end,
        class: 'word-timed cursor-pointer hover:bg-blue-100/50 rounded-sm transition-colors',
      }),
      0,
    ]
  },

  addOptions() {
    return {
      onWordClick: undefined as ((start: number, end: number) => void) | undefined,
    }
  },
})
